<script>

import parseDate from 'date-fns/parse'
import lazyLoadComponent from '@router/lazyload-component'
import { debounce } from 'lodash'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'
// import draggable from 'vuedraggable'
import ElTableDraggable from 'element-ui-el-table-draggable'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, defaultStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { authComputed } from '@state/helpers'
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import Sortable from "sortablejs";

export default {

  components: {

  },
  filters: {

  },
  mixins: [pageMixin],
  props: {
    
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pageSize:10,
      tableData: [],
      selectedMemberLevel: [],
      tryingFetch: false,
      filterData: {
        state:'',
        mode:''
      },
      draggable: true,
      action: ''
    }
  },
  computed: {
    ...authComputed,
    isOrderManager() {
      return !this.currentUserRoutes.includes('add-prepaid') && this.currentUserRoutes.includes('prepaid')
    },
    disabledAction() {
      return this.selectedMemberLevel.length === 0
    },
  },
  watch: {
    currentPage: {
      handler: 'tryToFetchMemberLevelList',
      immediate: false,
    },
    pageSize: {
      handler(){
        this.tryToFetchMemberLevelList()
        this.currentPage=1
      },
      immediate: false,
    },
  },
  created() {
    const page = this.$route.params.pagination
    if(page){
      const data = {...this.$route.params.filterData}
      this.filterData.productIds = data.productIds
      this.filterData.categoryId = data.categoryId
      this.filterData.search = data.search
      this.currentPage=page
      if(this.currentPage === 1){
        this.tryToFetchMemberLevelList()
      }

    }else{
      this.tryToFetchMemberLevelList('filter')
    }
  },
  mounted() {
    this.draggable && this.initSortable();
  },
  methods: {
    initSortable() {
      const $el = this.$refs.table.$el.querySelector(".el-table__body-wrapper > table > tbody")
      Sortable.create($el, {
        handle: ".sortable-handler",
        animation: 180,
        selectedClass: 'selectedItem',
        onEnd: ({ newIndex, oldIndex }) => {
          if (newIndex === 0 && oldIndex === 0) return
          const indexDiff =  newIndex - oldIndex
          const dragItem = this.tableData.splice(oldIndex, 1)[0];
          this.tableData.splice(newIndex, 0, dragItem);

          this.onOrderChange({
            id: this.tableData[newIndex].id,
            indexDiff
          })
        },
      });
    },
    async onOrderChange(submitData) {
      await this.$store.dispatch("memberLevel/ordering", {submitData})
      .then(() => {
        this.tryToFetchMemberLevelList()
      });
    },
    async tryToFetchMemberLevelList(type) {
      // if(!this.currentUserRoutes.includes('view-memberlevel')) return
      if (this.currentPage !== 1 && type === 'filter') {
        this.currentPage = 1
        return
      }
      this.tryingFetch = true
      const query = {...this.filterData}
      const { items, total } = await this.$store.dispatch('memberLevel/fetchList', Object.assign(query, {
        limit:this.pageSize,
        paginate: 0
      }))
      this.tableData = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
      this.tryingFetch = false
    },
    handleSelectionChange(selected) {
      this.selectedMemberLevel = selected.map(({ id }) => id)
    },
    goToAddMemberLevel(data) {
      this.$router.push({
        name: 'add-memberlevel',
      })
    },
    goToViewPage(row) {
      const id = row.id
      this.$router.push({
        name:'view-memberlevel',
        params:{
          id
        }
      })
    },
    periodTypeOption(type) {
      const map = {
        day: '天',
        month: '個月',
        year: '年'
      }
      return map[type] ?? '-'
    },
    handleResetSearch() {
      this.filterData =  {
        state:'',
        mode:''
      }
      this.tryToFetchMemberLevelList()
    },
    async handleStoreMemberLevel(state) {
      if (state === -1)
        await messageBoxDelete('等級方案')

      try {
        const memberLevelIds = this.selectedMemberLevel
        await this.$store.dispatch('memberLevel/updateState', { ids: memberLevelIds, state })
        if (state === -1)
          messageDelete()
        this.action = ''
        this.tryToFetchMemberLevelList()
      } finally {

      }
    },
    onSelectAction(action) {
      this.handleStoreMemberLevel(action)
    },
    canSelect(row,index){
      if(!row.default){
        return 1
      }else {
        return 0
      }
    },
  },
}
</script>

<template>
  <div :class="[$style.pageContent, $style.MemberLevelSetting]">
    <div :class="$style.btnTop" class="">
      <div class="d-flex justify-content-end">
        <span>
          <el-button class="is-round" type="primary" @click="goToAddMemberLevel({})">
            <BaseIcon name="plus"/>
            <span>新增等級</span>
          </el-button>
        </span>
        <span class="ml-3">
          <el-select v-model="action" placeholder="批次執行" :disabled="disabledAction" class="is-border" @change="onSelectAction">
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="0"></el-option>
            <el-option label="刪除" :value="-1"></el-option>
          </el-select>
        </span>
      </div>
      <!-- <span>
        <el-select v-model="action" placeholder="批次執行" :disabled="disabledAction" @change="onSelectAction">
          <el-option label="上架" :value="1"></el-option>
          <el-option label="下架" :value="0"></el-option>
          <el-option label="刪除" :value="-2"></el-option>
        </el-select>
      </span> -->
    </div>
    <div class="MemberLevelSetting__content">
      <BaseTableSearch 
        v-slot="{ fields }" 
        hide-action 
        :default-value="filterData"
        @reset="handleResetSearch" 
        @tryToFetchMemberLevelList="tryToFetchMemberLevelList('filter')"
      >
        <el-form-item prop="state">
          <el-select v-model="fields.state" placeholder="上架狀態" @change="tryToFetchMemberLevelList('filter')">
            <el-option label="所有上架狀態" value></el-option>
            <el-option label="已上架" value="1"></el-option>
            <el-option label="下架中" value="0"></el-option>
          </el-select>
        </el-form-item>
        
      </BaseTableSearch>
      <div class="isStylePageContent pt-0">
        <el-table
          ref="table" 
          v-loading="tryingFetch" 
          element-loading-text="取得會員等級資訊中" 
          :data="tableData" :class="$style['table']" 
          row-key="id" 
          @row-click.once="goToViewPage"
          @selection-change="handleSelectionChange"
        >
            <el-table-column 
              v-if="!isOrderManager" 
              type="selection" 
              label="全選" 
              width="120"
              :selectable='canSelect'
              disabled='true'
            >
            </el-table-column>

            <el-table-column v-slot="{ row }" label="等級方案名稱"  min-width="160">
              {{ row.title }} <br />
            </el-table-column>
            <el-table-column v-slot="{ row }" label="效期"  min-width="70">
              {{ row.periodType === 'lifelong' ? '無期限' : `${row.period + periodTypeOption(row.periodType)}` }}
            </el-table-column>
            <el-table-column v-slot="{ row }" label="上架" min-width="60">
              <BaseIcon v-if="row.state" name="check" style="color:#60A32F" />
              <BaseIcon v-else name="minus" icon-style="fal" />
            </el-table-column>
            <el-table-column v-if="draggable && !filterData.state && !filterData.mode" label="等級排序" min-width="100" prop="ordering">
            <template slot-scope="scope">
                <el-button type="text" class="caret-wrapper sortable-handler">
                  <BaseIcon icon-style="fas" name="fa-grip-dots-vertical" />
                </el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.MemberLevelSetting {
  .btnTop {
    padding: 0.5em 0;
    margin-bottom: 10px;
  }
  :global {
    .MemberLevelSetting {
      &__content {
        // padding: 0 1.125rem 1.125rem;
        // background: #fff;
      }
    }
    
  }
}
:global {
  .cursor {
    cursor: pointer;
  }
  .disabled {
    td {
      .cell {
        color: #E4E7ED;
      }
    }
  }
  .shortable {
    &-ghost td {
      background-color: lighten($color-primary, 50)
    }
  }
}
</style>
